<template>
  <div class="user-learning-progress-view">
    <ImageBar title="我的学习进度" height="80px"/>
    
    <div class="progress-container">
      <div class="main-content">
        <UserLearningProgress />
      </div>
      
      <div class="sidebar">
        <KnowledgeCourseRecommendations />
      </div>
    </div>
  </div>
</template>

<script>
import ImageBar from '@/components/ImageBar.vue'
import UserLearningProgress from '@/components/UserLearningProgress.vue'
import KnowledgeCourseRecommendations from '@/components/KnowledgeCourseRecommendations.vue'

export default {
  name: 'UserLearningProgressView',
  components: {
    ImageBar,
    UserLearningProgress,
    KnowledgeCourseRecommendations
  },
  created() {
    //检查是否登录
    if (!this.$root.isLoggedIn) {
      this.$goToLogin(this.$route.fullPath)
    }
  }
}
</script>

<style scoped>
.user-learning-progress-view {
  min-height: 100vh;
  background: #f5f7fa;
}

.progress-container {
  max-width: none;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 20px;
  box-sizing: border-box;
}

.main-content {
  min-width: 0;
}

.sidebar {
  min-width: 0;
}

/* 响应式设计 */
@media (max-width: 1800px) {
  .progress-container {
    grid-template-columns: 1fr;
  }
  
  .sidebar {
    order: -1;
  }
}

@media (max-width: 768px) {
  .progress-container {
    padding: 16px;
  }
}
</style> 